import React, { useEffect, useState, useParams } from 'react';
import { withRouter } from "react-router-dom";
import { useForm } from 'react-hook-form';
import { Button, Form } from 'react-bootstrap';
import Api from '../Services/Api';
import Alert from '../Services/Alert';

export const MoneySetting = (props) => {

    const [settingInfo, setSettingInfo] = useState({
        bonus_amount: "",
        minimum_deposit_amount: "",
        maximum_deposit_amount: "",
        deposit_bonus_amount: "",
        auto_withd_min_amount: "",
        auto_withd_max_amount: "",
        referral_bonus_amount: "",
        min_deposit_amount_for_bonus: "",
        whatsapp_no: "",
        calling_phone_no: "",
        email_id: "",
        is_whatsapp_enabled: "",
        is_live_chat_enabled: "",
    });
    const { register, handleSubmit, reset, formState: { errors } } = useForm({ mode: "onChange", defaultValues: settingInfo });

    const onSubmit = async (data) => {
        var sdata = {
            ...data,
            deposit_bonus_amount: (data.deposit_bonus_amount !== undefined && data.deposit_bonus_amount !== null && data.deposit_bonus_amount !== '') ? data.deposit_bonus_amount : "0",
        };
        console.log('sdata', sdata);
        Api.post('update_setting_amount', sdata).then((res) => res.data).then(res => {
            if (res.status) {
                Alert.success(res.message);
            } else {
                Alert.error(res.message)
            }
        }).catch(error => {
            Alert.error(error.message)
        })
    }

    useEffect(() => {

        Api.post('setting').then(resp => {
            var respData = resp.data;
            if (respData.status == 1) {
                let tempData = {
                    bonus_amount: respData.data.bonus_amount !== undefined && respData.data.bonus_amount !== null ? respData.data.bonus_amount.toString() : "0",
                    minimum_deposit_amount: respData.data.minimum_deposit_amount !== undefined && respData.data.minimum_deposit_amount !== null ? respData.data.minimum_deposit_amount.toString() : "100",
                    maximum_deposit_amount: respData.data.maximum_deposit_amount ? respData.data.maximum_deposit_amount.toString() : "50000",
                    deposit_bonus_amount: respData.data.deposit_bonus_amount !== undefined && respData.data.deposit_bonus_amount !== null ? respData.data.deposit_bonus_amount.toString() : "0",
                    auto_withd_min_amount: respData.data.auto_withd_min_amount !== undefined && respData.data.auto_withd_min_amount !== null ? respData.data.auto_withd_min_amount.toString() : "1000",
                    auto_withd_max_amount: respData.data.auto_withd_max_amount ? respData.data.auto_withd_max_amount.toString() : "100000",
                    referral_bonus_amount: respData.data.referral_bonus_amount !== undefined && respData.data.referral_bonus_amount !== null ? respData.data.referral_bonus_amount.toString() : "0",
                    min_deposit_amount_for_bonus: respData.data.min_deposit_amount_for_bonus !== undefined && respData.data.min_deposit_amount_for_bonus !== null ? respData.data.min_deposit_amount_for_bonus.toString() : "0",
                    whatsapp_no: respData.data.whatsapp_no || "",
                    calling_phone_no: respData.data.calling_phone_no || "",
                    email_id: respData.data.email_id || "",
                    is_whatsapp_enabled: (respData.data.is_whatsapp_enabled !== undefined && respData.data.is_whatsapp_enabled !== null ? respData.data.is_whatsapp_enabled.toString() : "1"),
                    is_live_chat_enabled: (respData.data.is_live_chat_enabled !== undefined && respData.data.is_live_chat_enabled !== null ? respData.data.is_live_chat_enabled.toString() : "0"),
                }
                setSettingInfo(tempData)
                reset(tempData);
            } else {
                Alert.error(respData.message)
            }
        });
    }, []);

    return (
        <>
            <div className="card">
                <div className="card-body">
                    <h4 className="card-title mb-4">Money / Limits / Support Settings</h4>
                    <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                        
                        <h5 className="text-primary mb-3">Deposit & Withdrawal Limits</h5>
                        <div className="row">
                            <div className="col-lg-3">
                                <Form.Group className="mb-3" controlId="formMinDeposit">
                                    <Form.Label>Min Deposit Amount (₹)</Form.Label>
                                    <Form.Control type="text" placeholder="Enter Min Deposit Amount" className="form-control" ref={register} {...register("minimum_deposit_amount", {
                                        required: true, maxLength: 80, pattern: {
                                            value: /^[0-9]*$/
                                        } })} />
                                    <div className="error">
                                        {errors.minimum_deposit_amount?.type === 'required' && "Minimum Deposit Amount is required"}
                                        {errors.minimum_deposit_amount?.type === 'pattern' && "Only digits allowed"}
                                    </div>
                                </Form.Group>
                            </div>
                            <div className="col-lg-3">
                                <Form.Group className="mb-3" controlId="formMaxDeposit">
                                    <Form.Label>Max Deposit Amount (₹)</Form.Label>
                                    <Form.Control type="text" placeholder="Enter Max Deposit Amount" className="form-control" ref={register} {...register("maximum_deposit_amount", {
                                        required: true, maxLength: 80, pattern: {
                                            value: /^[0-9]*$/
                                        } })} />
                                    <div className="error">
                                        {errors.maximum_deposit_amount?.type === 'required' && "Maximum Deposit Amount is required"}
                                        {errors.maximum_deposit_amount?.type === 'pattern' && "Only digits allowed"}
                                    </div>
                                </Form.Group>
                            </div>
                            <div className="col-lg-3">
                                <Form.Group className="mb-3" controlId="formMinWithdraw">
                                    <Form.Label>Min Withdrawal Amount (₹)</Form.Label>
                                    <Form.Control type="text" placeholder="Enter Min Withdrawal Amount" className="form-control" ref={register} {...register("auto_withd_min_amount", {
                                        required: true, maxLength: 80, pattern: {
                                            value: /^[0-9]*$/
                                        } })} />
                                    <div className="error">
                                        {errors.auto_withd_min_amount?.type === 'required' && "Minimum Withdrawal Amount is required"}
                                        {errors.auto_withd_min_amount?.type === 'pattern' && "Only digits allowed"}
                                    </div>
                                </Form.Group>
                            </div>
                            <div className="col-lg-3">
                                <Form.Group className="mb-3" controlId="formMaxWithdraw">
                                    <Form.Label>Max Withdrawal Amount (₹)</Form.Label>
                                    <Form.Control type="text" placeholder="Enter Max Withdrawal Amount" className="form-control" ref={register} {...register("auto_withd_max_amount", {
                                        required: true, maxLength: 80, pattern: {
                                            value: /^[0-9]*$/
                                        } })} />
                                    <div className="error">
                                        {errors.auto_withd_max_amount?.type === 'required' && "Maximum Withdrawal Amount is required"}
                                        {errors.auto_withd_max_amount?.type === 'pattern' && "Only digits allowed"}
                                    </div>
                                </Form.Group>
                            </div>
                        </div>

                        <h5 className="text-primary mb-3 mt-2">Bonus Settings</h5>
                        <div className="row">
                            <div className="col-lg-3">
                                <Form.Group className="mb-3" controlId="formBonusAmount">
                                    <Form.Label>Registration Bonus Amount (₹)</Form.Label>
                                    <Form.Control type="text" pattern="[0-9]*" placeholder="Enter Registration Bonus Amount" className="form-control" ref={register} {...register("bonus_amount", {
                                        required: true, maxLength: 80, pattern: {
                                            value: /^[0-9]*$/
                                        }, })} />
                                    <div className="error">
                                        {errors.bonus_amount?.type === 'required' && "Registration Bonus Amount is required"}
                                        {errors.bonus_amount?.type === 'pattern' && "Only digits allowed"}
                                    </div>
                                </Form.Group>
                            </div>
                            <div className="col-lg-3">
                                <Form.Group className="mb-3" controlId="formDepositBonus">
                                    <Form.Label>Deposit Bonus Amount (₹)</Form.Label>
                                    <Form.Control type="text" pattern="[0-9]*" placeholder="Enter Deposit Bonus Amount" className="form-control" ref={register} {...register("deposit_bonus_amount", {
                                        required: false, maxLength: 80, pattern: {
                                            value: /^[0-9]*$/
                                        }, })} />
                                    <div className="error">
                                        {errors.deposit_bonus_amount?.type === 'pattern' && "Only digits allowed"}
                                    </div>
                                </Form.Group>
                            </div>
                            <div className="col-lg-3">
                                <Form.Group className="mb-3" controlId="formReferralBonus">
                                    <Form.Label>Referral Bonus Amount (₹)</Form.Label>
                                    <Form.Control type="text" placeholder="Enter Referral Bonus Amount" className="form-control" ref={register} {...register("referral_bonus_amount", {
                                        required: true, maxLength: 80, pattern: {
                                            value: /^[0-9]*$/
                                        } })} />
                                    <div className="error">
                                        {errors.referral_bonus_amount?.type === 'required' && "Referral Bonus Amount is required"}
                                        {errors.referral_bonus_amount?.type === 'pattern' && "Only digits allowed"}
                                    </div>
                                </Form.Group>
                            </div>
                            <div className="col-lg-3">
                                <Form.Group className="mb-3" controlId="formMinDepositBonus">
                                    <Form.Label>Min. Deposit For Bonus (₹)</Form.Label>
                                    <Form.Control type="text" placeholder="Enter Min. Deposit For Bonus" className="form-control" ref={register} {...register("min_deposit_amount_for_bonus", {
                                        required: true, maxLength: 80, pattern: {
                                            value: /^[0-9]*$/
                                        } })} />
                                    <div className="error">
                                        {errors.min_deposit_amount_for_bonus?.type === 'required' && "Min. Deposit For Bonus is required"}
                                        {errors.min_deposit_amount_for_bonus?.type === 'pattern' && "Only digits allowed"}
                                    </div>
                                </Form.Group>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4">
                                <Form.Group className="mb-3" controlId="formTitle">
                                    <Form.Label>Whatsapp No.</Form.Label>
                                    <Form.Control type="text" placeholder="Enter Whatsapp No." className="form-control" ref={register} {...register("whatsapp_no", {
                                        required: true, maxLength: 80  })} />
                                    <div className="error">
                                        {errors.whatsapp_no?.type === 'required' && "Whatsapp No. is required"}
                                    </div>
                                </Form.Group>
                            </div>
                            <div className="col-lg-4">
                                <Form.Group className="mb-3" controlId="formTitle">
                                    <Form.Label>Calling Phone No.</Form.Label>
                                    <Form.Control type="text" placeholder="Enter Calling Phone No." className="form-control" ref={register} {...register("calling_phone_no", {
                                        required: true, maxLength: 80 })} />
                                    <div className="error">
                                        {errors.calling_phone_no?.type === 'required' && "Calling Phone No. is required"}
                                    </div>
                                </Form.Group>
                            </div>
                            <div className="col-lg-4">
                                <Form.Group className="mb-3" controlId="formTitle">
                                    <Form.Label>Email ID</Form.Label>
                                    <Form.Control type="text" placeholder="Enter Email ID" className="form-control" ref={register} {...register("email_id", {
                                        required: true, maxLength: 80, pattern: {
                                            value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                            message: 'Enter valid email',
                                        }, })} />
                                    <div className="error">
                                        {errors.email_id?.type === 'required' && "Email ID is required"}
                                        {errors.email_id?.type === 'pattern' && "Enter valid email"}
                                    </div>
                                </Form.Group>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>WhatsApp Chat</Form.Label>
                                    <div className="col-lg-12">
                                        <Form.Check inline label="ON" value="1" id="on-whatsapp" type="radio" {...register("is_whatsapp_enabled", { required: true })} />
                                        <Form.Check inline label="OFF" id="off-whatsapp" type="radio" value="0" {...register("is_whatsapp_enabled", { required: true })} />
                                        <div className="error">
                                            {errors.is_whatsapp_enabled?.type === 'required' && "WhatsApp Chat setting is required"}
                                        </div>
                                    </div>
                                </Form.Group>
                            </div>
                            <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Live Chat (In-App)</Form.Label>
                                    <div className="col-lg-12">
                                        <Form.Check inline label="ON" value="1" id="on-livechat" type="radio" {...register("is_live_chat_enabled", { required: true })} />
                                        <Form.Check inline label="OFF" id="off-livechat" type="radio" value="0" {...register("is_live_chat_enabled", { required: true })} />
                                        <div className="error">
                                            {errors.is_live_chat_enabled?.type === 'required' && "Live Chat setting is required"}
                                        </div>
                                    </div>
                                </Form.Group>
                            </div>
                        </div>
                        <div className="btn-submit">
                            <Button className="btn btn-primary w-md" type="submit">Update Setting</Button>
                        </div>
                    </Form>
                </div>
            </div>        
        </>
    )
}

export default withRouter(MoneySetting);